import { get } from "svelte/store";
import { authStore } from "$lib/stores";
import "$lib/utility/logger";

export async function load({ data }: { data: Record<string, unknown> }) {
  const auth = get(authStore);
  return {
    ...(data || {}),
    auth,
  };
}

export const ssr = true;
export const csr = true;
